import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";

export default function SignOut() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    logout();
    // Use replace to replace current history entry
    const isMobile = location.pathname === "/m" || location.pathname.startsWith("/m/");
    navigate(isMobile ? "/m/authentication/sign-in" : "/authentication/sign-in", { replace: true });
  }, [logout, navigate, location.pathname]);

  return null;
}
